export const environment = {
  production: false,
  // apiBaseUrl: 'https://elvwebservice.digielv.com/api',
  // apiBaseUrls: {
  //   lead: 'http://91.203.134.254:8082/',
  //   base: 'http://91.203.134.254:8081/',
  // },

  apiBaseUrls: {
    lead: 'https://autoloop-api-lead.kiraninfosoft.in/',
    base: 'https://autoloop-api-user.kiraninfosoft.in/',
  },  
  
  // apiBaseUrls: {
  //   lead: 'http://192.168.0.18:8082/',
  //   base: 'http://192.168.0.18:8081/',
  // },
};
